import { HttpBadStatusCodeError } from '../../../errors/shared/http.js';
import { sendHttpRequest } from '../../../http/browser/client.js';
import '../../../result/shared/result.js';
import '../../../iterator/shared/iterator.js';
import '../../../http/shared/headers/contentType.js';
import '../../../http/browser/types.js';
import { createBaseStdoutLogger } from '../baseStdoutLogger.js';

const NAMESPACE = 'core.logger.transport.http';
class HTTPTransport {
    formatter;
    url;
    logger = createBaseStdoutLogger(NAMESPACE, {
        pretty: process.env.NODE_ENV === 'development',
    });
    // oxlint-disable-next-line typescript/parameter-properties
    constructor(formatter, url) {
        this.formatter = formatter;
        this.url = url;
    }
    write(appLog) {
        const log = this.formatter.format(appLog);
        sendHttpRequest(this.url, {
            method: 'POST',
            body: JSON.stringify({ error: log }),
            headers: {
                'Content-Type': 'application/json',
            },
            logger: this.logger,
        })
            .then(this.handleResult)
            .catch(this.catchError);
    }
    handleResult = (result) => {
        if (result.isErr()) {
            this.logger.error(result.Err);
        }
        else {
            if (result.Ok.statusCode > 204) {
                this.logger.error(new HttpBadStatusCodeError({ statusCode: result.Ok.statusCode, domain: NAMESPACE, url: this.url.toString() }));
            }
        }
    };
    // oxlint-disable-next-line typescript/no-explicit-any
    catchError = (err) => {
        this.logger.error(err);
    };
}

export { HTTPTransport };
//# sourceMappingURL=HTTPTransport.js.map
